import React, { useState } from "react";
import styled from "styled-components";
import { useGlobalModal } from "../../../contexts/GlobalModalContext";
import { OutlinedButtonStyled } from "../OutlinedButtonStyled";
import { exportBackgroundCheckPersonnel } from "../../../api/ExportApi";
import { exportDrugTestingPersonnel } from "../../../api/ExportApi";
import FileUtil from "../../../util/FileUtil";
import { PersonnelTypes } from "../../../constants/PersonnelTypes";

const BodyContent = styled.div`
    text-align: left;
    margin-bottom: 10px;
    padding: 0.5rem;
`;

const LoadingIndicator = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    color: #4c8cee;
    font-size: 14px;
    font-weight: bold;
`;

const Spinner = styled.div`
    border: 2px solid #f3f3f3;
    border-top: 2px solid #4c8cee;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    animation: spin 1s linear infinite;
    margin-right: 8px;

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

type ExportModalBodyProps = {};

const ExportModalBodyContent: React.FC<ExportModalBodyProps> = ({}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("");

    const {
        state: {
            selectedMenuOptions,
            affiliationFilters,
            searchText,
            inactiveSelected,
            sortFilters,
        },
    } = useGlobalModal();

    const exportBackgroundCheck = () => {
        setIsLoading(true);
        setLoadingMessage("Preparing Background Check export...");

        const personnelSearch = {
            searchText: searchText && searchText.length !== 0 ? searchText : null,
            orgIds: affiliationFilters ? affiliationFilters.map((opt: any) => opt.orgId) : null,
            personnelType: PersonnelTypes.CLUB,
            statuses: inactiveSelected ? [-1] : selectedMenuOptions.map((opt: any) => opt.id),
        };

        let sortFilterCol = sortFilters.col;
        if (sortFilterCol === "affiliateNameLevel") {
            sortFilterCol = "affiliation.name";
        }
        if (sortFilterCol === "org") {
            sortFilterCol = "affiliation.orgAbbreviation";
        }
        exportBackgroundCheckPersonnel(personnelSearch, sortFilters.dir, sortFilterCol)
            .then(response => {
                FileUtil.downloadFile(response, "xlsx");
                setIsLoading(false);
                setLoadingMessage("");
            })
            .catch(error => {
                console.error("Export failed:", error);
                setIsLoading(false);
                setLoadingMessage("");
            });
    };

    const exportDrugTesting = () => {
        setIsLoading(true);
        setLoadingMessage("Preparing Drug Testing export...");

        const personnelSearch = {
            searchText: searchText && searchText.length !== 0 ? searchText : null,
            orgIds: affiliationFilters ? affiliationFilters.map((opt: any) => opt.orgId) : null,
            personnelType: PersonnelTypes.CLUB,
            statuses: inactiveSelected ? [-1] : selectedMenuOptions.map((opt: any) => opt.id),
        };

        let sortFilterCol = sortFilters.col;
        if (sortFilterCol === "affiliateNameLevel") {
            sortFilterCol = "affiliation.name";
        }
        if (sortFilterCol === "org") {
            sortFilterCol = "affiliation.orgAbbreviation";
        }
        exportDrugTestingPersonnel(personnelSearch, sortFilters.dir, sortFilterCol)
            .then(response => {
                FileUtil.downloadFile(response, "xlsx");
                setIsLoading(false);
                setLoadingMessage("");
            })
            .catch(error => {
                console.error("Export failed:", error);
                setIsLoading(false);
                setLoadingMessage("");
            });
    };

    return (
        <div>
            <div className="d-flex">
                <BodyContent>
                    <OutlinedButtonStyled
                        width={142}
                        height={26}
                        disabled={isLoading}
                        onClick={exportBackgroundCheck}
                    >
                        Background Check
                    </OutlinedButtonStyled>
                </BodyContent>
            </div>
            {isLoading && (
                <LoadingIndicator>
                    <Spinner />
                    {loadingMessage}
                </LoadingIndicator>
            )}
        </div>
    );
};

const ExportModalFooterContent = () => {
    const {
        state: { yesCallback },
        closeModal,
    } = useGlobalModal();

    return (
        <div className="d-flex">
            <div className="pl-2" />
        </div>
    );
};

ExportModalBodyContent.displayName = "BodyContent";
ExportModalFooterContent.displayName = "FooterContent";

export { ExportModalBodyContent, ExportModalFooterContent };
